<ng-content></ng-content>

@if (!hideArrow()) {
  <sd-icon class="arrow icon-size-xxs" [type]="iconTypes.ARROW_DOWN"></sd-icon>
}
